import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import UserLayout from "layouts/user";
import SuperAdminLayout from "layouts/super-admin";
import PageNotFound from "./layouts/PageNotFound";
import { getCookie } from "utils/cookie"; // Assumes a utility to remove cookies exists

const PrivateRoute = ({ children }) => {
  const token = getCookie("token");

  if (!token) {
    // Remove any remnants of the session (if needed)
    localStorage.clear();

    // If no token exists, redirect to login
    return <Navigate to="/auth" replace />;
  }

  // If token exists, render the private component
  return children;
};

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(!!getCookie("token"));

  useEffect(() => {
    const token = getCookie("token");
    if (!token) {
      // If no token, ensure user is logged out and redirected
      localStorage.clear();
      setIsLoggedIn(false);
    }
  }, []);

  return (
    <Routes>
      {/* Public routes */}
      <Route path="auth/*" element={<AuthLayout />} />

      {/* Private routes */}
      <Route
        path="admin/*"
        element={
          <PrivateRoute>
            <AdminLayout />
          </PrivateRoute>
        }
      />
      <Route
        path="super-admin/*"
        element={
          <PrivateRoute>
            <SuperAdminLayout />
          </PrivateRoute>
        }
      />
      <Route
        path="user/*"
        element={
          <PrivateRoute>
            <UserLayout />
          </PrivateRoute>
        }
      />
      <Route
        path="*"
        element={
          <PrivateRoute>
            <PageNotFound />
          </PrivateRoute>
        }
      />

      {/* Redirect to the appropriate page based on login status */}
      <Route
        path="/"
        element={
          <Navigate
            to={
              isLoggedIn
                ? getCookie("role") === "user"
                  ? "/user"
                  : getCookie("role") === "super-admin"
                  ? "/super-admin"
                  : "/admin"
                : "/auth"
            }
            replace
          />
        }
      />
    </Routes>
  );
};

export default App;
